import api from '../apiService';
import { populateFields, clearFields, propSpinner, disableSaveButton, createDebouncedMemoRequest } from '../utils';

const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

export async function fetchIstatCode(cityField, istatField) {
    const cityName = $('select[name="' + cityField + '"]').val();
    if (!cityName) {
        clearFields([istatField]);
        return;
    }

    propSpinner([istatField], true);
    disableSaveButton(true);

    const cacheKey = `${cityField}-${istatField}-${cityName}`;

    debounceSearch(cacheKey, `/api/app/backpack/fetch-istat-code`, {
        params: { city_name: cityName },
    }).then((data) => {
        if (data.istat) {
            populateFields({ [istatField]: data.istat });
        }
    })
    .catch(() => {
        clearFields([istatField]);
    })
    .finally(() => {
        propSpinner([istatField], false);
        disableSaveButton(false);
    });
}
